// In-memory access-token holder.
//
// HARD RULE (docs/DASHBOARD.md, IMPLEMENTATION_PLAN §5): the access token lives ONLY in
// memory — never localStorage/sessionStorage. It vanishes on reload; the session is
// re-bootstrapped via a silent refresh (httpOnly refresh cookie) instead. Keeping it in a
// module variable (not React state) lets the non-React fetch client read it synchronously.

let accessToken: string | null = null;

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}
